<template>
  <form class="search" action="" onsubmit="event.preventDefault();">
    <input
      type="text"
      v-model="search_word"
      name="search_word"
      :placeholder="placeholder_text"
      @click="searchWindowClick()"
      @input="getSearchResult()"
    >
    <div
      v-if="searchMenu.isActive"
      class="spSearchMenu"
      :class="searchMenu.selected.target ? 'selected' : ''"
      v-click-outside="closeModal"
    >
      <div v-if="searchMenu.selected.target" class="spSearchMenu_header">
        <img
          @click="back()"
          src="/assets/img/common/spSearchMenu_header_arrow_left.svg"
          alt="back"
          class="back"
        >
          {{ searchMenuHeaderTitle }}
      </div>
      <ul v-if="!searchMenu.selected.target" class="spSearchMenu_list">
        <li
          v-for="(menu, key) in searchMenu.shopSearch"
          :key="key"
          class="spSearchMenu_list_item" :class="{ 'keyword': menu.title === 'キーワードから探す' }"
          @click.stop="selectTarget(key)"
        >
          <div class="container">
            <div class="icon">
              <img :src="menu.iconPath" :alt="key"/>
            </div>
            {{ menu.title }}
          </div>
        </li>
        <li
            v-if="searchWordList && searchWordList.length > 0"
            v-for="(shop, key) in searchWordList"
            :key="key"
            class="spSearchMenu_list_item wordList"
            @click.stop="selectTarget(key)"
        >
          <a :href="shop.top_url" class="container">
            {{ shop.display_name }}
          </a>
        </li>
        <li v-else-if="search_word" class="spSearchMenu_list_item wordList noList">
          <div class="container">
            {{ search_message }}
          </div>
        </li>
      </ul>
      <ul
        v-if="searchMenu.selected.target && searchMenu.selected.childrenList.length === 0"
        class="spSearchMenu_list"
      >
        <li
          v-for="(parent, key) in searchMenu.selected.parentList"
          :key="key"
          class="spSearchMenu_list_item"
          @click="selectCategory(parent)"
        >
          <div class="container">
            <div class="icon">
              <img :src="setIcon(parent.id)" :alt="parent.name_public"/>
            </div>
            {{ parent.name_public }}
          </div>
        </li>
      </ul>
      <ul
        v-if="searchMenu.selected.target && searchMenu.selected.childrenList.length !== 0"
        class="spSearchMenu_imgList"
      >
        <li class="spSearchMenu_imgList_item">
          <a :href="pageLink()">
            <div class="img">
              <img :src="parentSrc()" alt="全て">
            </div>
          </a>
          <div class="name">全て</div>
        </li>
        <li
          v-for="(children, key) in searchMenu.selected.childrenList"
          :key="key" class="spSearchMenu_imgList_item"
        >
          <a :href="pageLink(children.id)">
            <div class="img">
              <img :src="src(children.image_url)" :alt="children.name_public">
            </div>
          </a>
          <div class="name">{{ children.name_public }}</div>
        </li>
      </ul>
    </div>
  </form>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
export default {
  props: {
    shopCategory: {
      type: Array,
      required: true,
    },
    shopArea: {
      type: Array,
      required: true,
    },
    imagePath: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentController: null,
      placeholder_text: 'お店やお得なクーポンを探す',
      search_message: '',
      search_word: null,
      searchWordList: [],
      searchMenu: {
        isActive: false,
        selected: {
          target: '',
          categoryId: null,
          islandId: null,
          parentList: [],
          childrenList: []
        },
        shopSearch: {
          genre: {
            iconPath: '/assets/img/common/genre.svg',
            title: 'ジャンルから探す'
          },
          area: {
            iconPath: '/assets/img/common/area.svg',
            title: 'エリアから探す'
          },
          currentLocation: {
            iconPath: '/assets/img/common/current_location.svg',
            title: '現在地から探す'
          },
          keyword: {
            iconPath: '/assets/img/common/search_blue.svg',
            title: 'キーワードから探す'
          }
        }
      },
      categoryIcon: [
        {
          id: 6,
          icon_url: '/assets/img/common/gourmet.svg'
        },
        {
          id: 36,
          icon_url: '/assets/img/common/bag.svg'
        },
        {
          id: 31,
          icon_url: '/assets/img/common/beauty.svg'
        },
        {
          id: 41,
          icon_url: '/assets/img/common/rental.svg'
        },
        {
          id: 20,
          icon_url: '/assets/img/common/yacht.svg'
        }
      ]
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  mounted() {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    this.search_word = urlParams.get('search_word')
  },
  computed: {
    searchMenuHeaderTitle() {
      if (this.searchMenu.selected.target === 'genre') {
        if (!this.searchMenu.selected.categoryId) {
          return 'カテゴリーを選ぶ'
        } else {
          return 'ジャンルを選ぶ'
        }
      } else if (this.searchMenu.selected.target === 'area') {
        if (!this.searchMenu.selected.islandId) {
          return '島を選ぶ'
        } else {
          return 'エリアを選ぶ'
        }
      }
    }
  },
  methods: {
    closeModal() {
      this.reset()
    },
    back() {
      if (this.searchMenu.selected.target === 'genre') {
        if (this.searchMenu.selected.categoryId) {
          this.searchMenu.selected.categoryId = null
          this.searchMenu.selected.childrenList = []
        } else {
          this.searchMenu.selected.target = ''
        }
      }
      if (this.searchMenu.selected.target === 'area') {
        if (this.searchMenu.selected.islandId) {
          this.searchMenu.selected.islandId = null
          this.searchMenu.selected.childrenList = []
        } else {
          this.searchMenu.selected.target = ''
        }
      }
    },
    isActive(active) {
      return this.active === active
    },
    searchWindowClick() {
      this.placeholder_text = '気になるお店の名前を入力！';
      this.searchMenu.isActive = true
      document.body.style.overflow = 'hidden';
    },
    selectTarget(key) {
      if (key === 'currentLocation' || key === 'keyword') {
        if (this.search_word) {
          window.location.href = `/shop/search?search_word=${this.search_word}`
        } else {
          window.location.href = `/shop/search`
        }
        return
      }
      if (key === 'genre') {
        // ホテル除外
        this.searchMenu.selected.parentList = this.shopCategory.filter(item => item.id !== 26)
      } else if (key === 'area') {
        this.searchMenu.selected.parentList = this.shopArea
      }
      this.searchMenu.selected.target = key
    },
    selectCategory(parent) {
      let target = this.searchMenu.selected.target
      if (target === 'genre') {
        this.searchMenu.selected.categoryId = parent.id
      } else if (target === 'area') {
        this.searchMenu.selected.islandId = parent.id
      }
      this.searchMenu.selected.childrenList = parent.children
    },
    pageLink(id) {
      if (id) {
        return `/shop/search?${this.searchMenu.selected.target}=${id}`
      } else {
        // 全ての場合
        if (this.searchMenu.selected.categoryId || this.searchMenu.selected.islandId) {
          const ids = this.searchMenu.selected.childrenList.map(v => v.id)
          // 配列をカンマ区切りの文字列に変換
          const stringId = ids.join(',')
          return `/shop/search?${this.searchMenu.selected.target}=${stringId}`
        }
      }
    },
    reset() {
      this.placeholder_text = 'お店やお得なクーポンを探す';
      this.searchMenu.isActive = false
      this.searchMenu.selected = {
        target: '',
        categoryId: null,
        islandId: null,
        parentList: [],
        childrenList: []
      }
      document.body.style.overflow = ""
    },
    setIcon(id) {
      if (this.searchMenu.selected.target === 'genre') {
        let icon = this.categoryIcon.find(item => item.id === id)
        return icon.icon_url
      } else {
        return '/assets/img/common/area.svg'
      }
    },
    parentSrc() {
      const targetId = this.searchMenu.selected.categoryId ?? this.searchMenu.selected.islandId ?? null;
      if (targetId) {
        let parent = this.searchMenu.selected.parentList.find(item => item.id === targetId)
        return this.imagePath + parent.image_url
      } else {
        return '/img/aloco_img_2.svg'
      }
    },
    src(url) {
      if(url) {
        return this.imagePath + url
      } else {
        return '/img/aloco_img_2.svg'
      }
    },
    getSearchResult() {
      let timerId;
      clearTimeout(timerId);
      if(this.currentController){
        // 既存の通信が存在するならばここでキャンセル
        this.currentController.abort();
      }
      this.search_message = '検索中...';
      // 通信キャンセル用のインスタンスを用意
      const controller = new AbortController();
      // 既存の通信のコントローラーとしてこのイベント中の axios を制御する AbortController を変数に格納
      this.currentController = controller;
      // axios で通信
      axios.get('/api/search_shop', { params: { search_word: this.search_word }, signal: controller.signal })
        .then(res => {
          this.searchWordList = res.data.shops
          if (this.searchWordList.length) {
            this.search_message = '';
          } else {
            this.search_message = '該当する店舗が見つかりませんでした。';
          }
        })
        .catch(error => {
          // console.error(error)
        })
        .finally(() => {
          // 通信が完了したならば、キャンセル用のコントローラーを入れる変数を空にする
          // this.currentController = null;
        });
    }
  },
  watch: {
    'searchMenu.isActive': function(newValue, oldValue) {
      const footerAd = document.querySelector('.footer-ad')
      if (newValue) {
        footerAd.classList.add('none')
      } else {
        footerAd.classList.remove('none')
      }
    }
  }
}
</script>
